<template>
  <div class="nc-spinner" :class="'nc-spinner--' + size">
    <svg class="nc-spinner__svg" viewBox="0 0 50 50">
      <circle
        cx="25" cy="25" r="20"
        fill="none"
        :stroke-width="strokeWidth"
        class="nc-spinner__track"
      />
      <circle
        cx="25" cy="25" r="20"
        fill="none"
        :stroke-width="strokeWidth"
        stroke-linecap="round"
        class="nc-spinner__fill"
        :class="'nc-spinner__fill--' + color"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'NcSpinner',
  props: {
    size: { type: String, default: 'md' },
    color: { type: String, default: 'primary' },
  },
  computed: {
    strokeWidth() {
      return this.size === 'sm' ? 4 : 3;
    },
  },
};
</script>

<style scoped>
.nc-spinner { display: inline-flex; }
.nc-spinner--sm { width: 20px; height: 20px; }
.nc-spinner--md { width: 32px; height: 32px; }
.nc-spinner--lg { width: 48px; height: 48px; }
.nc-spinner__svg { animation: nc-spin 1.4s linear infinite; }
.nc-spinner__track { stroke: rgba(20, 182, 154, 0.12); }
.nc-spinner__fill { stroke-dasharray: 80, 200; stroke-dashoffset: 0; animation: nc-dash 1.4s ease-in-out infinite; }
.nc-spinner__fill--primary { stroke: var(--nc-color-primary, #14b69a); }
.nc-spinner__fill--medium { stroke: var(--nc-text-muted, #92949c); }
.nc-spinner__fill--white { stroke: white; }
@keyframes nc-spin { 100% { transform: rotate(360deg); } }
@keyframes nc-dash {
  0% { stroke-dasharray: 1, 200; stroke-dashoffset: 0; }
  50% { stroke-dasharray: 80, 200; stroke-dashoffset: -30; }
  100% { stroke-dasharray: 80, 200; stroke-dashoffset: -125; }
}
</style>
